export default async function fetchValidation() {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/users/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`, 
    },
  });
}
